module.exports = __webpack_public_path__ + "static/media/courier_logo_fr.4caa465c.png";